import "../Style/Navbar.css"
import linkDin from "../Assets/Vector.svg"
import { Link } from "react-router-dom"
import Resume from "../Assets/Piyush_Kumar_Singh_SFE.docx";
import React, { useContext, useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import github from "../Assets/github.jpg"
import { DiGitMerge } from "react-icons/di";
import logo from "../Assets/logo.png"
import gsap from "gsap"
import { useGSAP } from "@gsap/react"
import { ThemeContext } from "../Theme/ThemeContext";
const Navbar = () => {
      const {theme} = useContext(ThemeContext);
    const [isOpen, setIsOpen] = useState(false);
    const [ismobilenav, setIsMobileNav] = useState(false)
    const container = useRef()
    // const timeline = useRef(gsap.timeline({ paused: true }));


    const HandlingNav = () => {
        setIsMobileNav(!ismobilenav)
        // if (!ismobilenav) {
        //     timeline.current.play(); // Play the animation forward when opening
        // } else {
        //     timeline.current.reverse(); // Reverse the animation when closing
        // }
    }

    useEffect(() => {
        if (ismobilenav) {


            gsap.fromTo(
                ".mobile-nav-ul li",
                { x: 500, opacity: 0 },
                {
                    x: 0,
                    opacity: 1,
                    duration: 1,
                    stagger: 0.30,
                    // ease: "power3.out",
                }
            )
            // Start with reverse so it's hidden initially

            // return () => {
            //     timeline.current.kill(); // Clean up GSAP on component unmount
            // };

        }



    }, [ismobilenav]);
    useEffect(() => {
        // Get original body overflow style so we can revert to it later on
        const originalStyle = window.getComputedStyle(document.body).overflow;

        // If the menu is open then set the overflow to hidden to prevent scrolling the page further
        if (ismobilenav) {
            document.body.style.overflow = 'hidden';
        }

        // Re-enable scrolling when component unmounts by reverting to the original body overflow style value
        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, [ismobilenav])

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    return (
        <>
            <nav id="Navbar" className={`Nav ${theme}`}  data-scroll-section> 
                <div className="Main-Contanier-Wrapper">
                    <div className="InnerWrapper">
                        <div>
                            <Link to={"/"} ><img src={logo} className="logo" alt="logo" /></Link>
                        </div>

                        <Modal isOpen={isOpen} onRequestClose={closeModal} contentLabel="Example Popup"
                            style={{
                                overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
                                content: {
                                    textAlign: "center",
                                    backgroundColor: '#dadbd8',
                                    height: "180px",
                                    width: "450px",
                                    top: '50%',
                                    left: '50%',
                                    right: 'auto',
                                    bottom: 'auto',
                                    marginRight: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }
                            }}>
                            <h2>Resume</h2>
                            <p style={{ color: "black" }}>Do you want do Download?</p>
                            <button style={{ height: "40px", width: "100px", }}  >
                                <a href={Resume} onClick={closeModal} style={{ color: "black" }} download>Yes</a></button>

                            <button onClick={closeModal} style={{ marginLeft: "25px", height: "40px", width: "100px", }} ><a style={{ color: "black" }}>No</a></button>
                        </Modal>
                        {/* <div className="about-project-div">

                            <Link to="/about" style={{ marginLeft: "25px", letterSpacing: "1px" }} > About </Link>
                            <Link to="/project" style={{ marginLeft: "25px", letterSpacing: "1px" }} > Projects</Link>
                            <Link>
                            <a href="#" onClick={openModal} style={{ marginLeft: "25px", letterSpacing: "1px" }} > Resume</a>
                            </Link>
                            
                        </div> */}


                    </div>
                    <div className="Social-Nav-Icon-Wrapper"  >
                        {/* 
                        <a className="nav-link-humburger-desktop" onClick={HandlingNav}>

                            <svg width="36" height="20" viewBox="0 0 56 42" fill="white" xmlns="http://www.w3.org/2000/svg">

                                <path d="M28 21L56 21" stroke="gray" strokeWidth="3" />
                                <path d="M0 41H56" stroke="white" strokeWidth="3" />
                            </svg>


                        </a> */}

                        {/* <a href="https://www.linkedin.com/in/piyush-kumar-singh-6234141ba" target="_blank" className="Social-Nav-Icon" ><svg width="16" height="16" viewBox="0 0 9 9" fill="white" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.375 8.75H2.0625V3.3125H0.375V8.75ZM1.21875 0.625C0.6875 0.625 0.25 1.0625 0.25 1.59375C0.25 2.125 0.6875 2.5625 1.21875 2.5625C1.75 2.5625 2.1875 2.125 2.1875 1.59375C2.1875 1.0625 1.75 0.625 1.21875 0.625ZM6.34375 3.1875C5.53125 3.1875 4.96875 3.625 4.75 4.0625H4.71875V3.3125H3.09375V8.75H4.78125V6.0625C4.78125 5.34375 4.90625 4.65625 5.78125 4.65625C6.65625 4.65625 6.65625 5.46875 6.65625 6.09375V8.75H8.375V5.78125C8.375 4.3125 8.0625 3.1875 6.34375 3.1875Z" fill="white" />
                        </svg>
                        </a>
                        <a href="https://github.com/Piyush2205" target="_blank" className="nav-link-github">
                            <DiGitMerge />
                        </a> */}
                        {/* ........................................................................................... */}
                        {
                            ismobilenav ? <a onClick={HandlingNav} className="nav-link-humburger" >
                                <svg width="36" height="20" viewBox="0 0 69 72" fill="black" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M67.0742 69.6382L5.17896 0.896528" stroke="black" stroke-width="5" />
                                    <line y1="-1.5" x2="92.5" y2="-1.5" transform="matrix(-0.694658 0.71934 -0.826695 -0.562651 64.2559 3)" stroke="black" stroke-width="5" />
                                </svg>

                                <div className="mobile-nav" >
                                    <div className="nav-social-section">
                                        <a href={"mailto:dev.piyush.singh@gmail.com"} className="mobile-nav-email">dev.piyush.singh@gmail.com</a>
                                        <a href={"https://www.linkedin.com/in/piyush-kumar-singh-6234141ba"} target="_blank" className="Social-Nav-Icon" ><svg width="16" height="16" viewBox="0 0 9 9" fill="white" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.375 8.75H2.0625V3.3125H0.375V8.75ZM1.21875 0.625C0.6875 0.625 0.25 1.0625 0.25 1.59375C0.25 2.125 0.6875 2.5625 1.21875 2.5625C1.75 2.5625 2.1875 2.125 2.1875 1.59375C2.1875 1.0625 1.75 0.625 1.21875 0.625ZM6.34375 3.1875C5.53125 3.1875 4.96875 3.625 4.75 4.0625H4.71875V3.3125H3.09375V8.75H4.78125V6.0625C4.78125 5.34375 4.90625 4.65625 5.78125 4.65625C6.65625 4.65625 6.65625 5.46875 6.65625 6.09375V8.75H8.375V5.78125C8.375 4.3125 8.0625 3.1875 6.34375 3.1875Z" fill="white" />
                                        </svg>
                                        </a>
                                        <a href={"https://github.com/Piyush2205"} target="_blank" className="nav-link-github">
                                            <DiGitMerge />
                                        </a>
                                    </div>
                                    <ul ref={container} className="mobile-nav-ul">

                                        <li><Link to="/" style={{ letterSpacing: "1px" }} className="mobile-nav-ul li" >Home</Link></li>
                                        <li><Link to="/about" style={{ letterSpacing: "1px" }} className="mobile-nav-ul li" >About </Link></li>
                                        <li><Link to="/project" style={{ letterSpacing: "1px" }} className="mobile-nav-ul li" >Projects</Link></li>
                                        <li><Link to="/contact" style={{ letterSpacing: "1px" }} className="mobile-nav-ul li" >Contact</Link></li>
                                        <li><Link to="/project" style={{ letterSpacing: "1px" }} className="mobile-nav-ul li"
                                            onClick={openModal} >Resume</Link></li>
                                    </ul>
                                    {/* <div className="nav-social-section">
                                        <a href={"mailto:dev.piyush.singh@gmail.com"} className="mobile-nav-email">dev.piyush.singh@gmail.com</a>
                                        <a href={"https://www.linkedin.com/in/piyush-kumar-singh-6234141ba"} target="_blank" className="Social-Nav-Icon" ><svg width="16" height="16" viewBox="0 0 9 9" fill="white" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.375 8.75H2.0625V3.3125H0.375V8.75ZM1.21875 0.625C0.6875 0.625 0.25 1.0625 0.25 1.59375C0.25 2.125 0.6875 2.5625 1.21875 2.5625C1.75 2.5625 2.1875 2.125 2.1875 1.59375C2.1875 1.0625 1.75 0.625 1.21875 0.625ZM6.34375 3.1875C5.53125 3.1875 4.96875 3.625 4.75 4.0625H4.71875V3.3125H3.09375V8.75H4.78125V6.0625C4.78125 5.34375 4.90625 4.65625 5.78125 4.65625C6.65625 4.65625 6.65625 5.46875 6.65625 6.09375V8.75H8.375V5.78125C8.375 4.3125 8.0625 3.1875 6.34375 3.1875Z" fill="white" />
                                        </svg>
                                        </a>
                                        <a href={"https://github.com/Piyush2205"} target="_blank" className="nav-link-github">
                                            <DiGitMerge />
                                        </a>
                                    </div> */}

                                </div>
                            </a>
                                :

                           <div>
                                {/* <div className="about-project-div">

                            <Link to="/about" style={{ marginLeft: "25px", letterSpacing: "1px" }} > About </Link>
                            <Link to="/project" style={{ marginLeft: "25px", letterSpacing: "1px" }} > Projects</Link>
                            <Link>
                            <a href="#" onClick={openModal} style={{ marginLeft: "10px", letterSpacing: "1px" }} > Resume</a>
                            </Link>
                            
                        </div> */}
                       <a className="nav-link-humburger" onClick={HandlingNav}>
                                  {theme === "theme-black" ?<svg width="36" height="20" viewBox="0 0 56 42" fill="black" xmlns="http://www.w3.org/2000/svg">
                                        {/* <path d="M0 1L56 1" stroke="white" strokeWidth="3" /> */}
                                        <path d="M28 21L56 21" stroke="white" strokeWidth="3" />
                                        <path d="M0 41H56" stroke="white" strokeWidth="3" />
                                    </svg>:<svg width="36" height="20" viewBox="0 0 56 42" fill="black" xmlns="http://www.w3.org/2000/svg">
                                        {/* <path d="M0 1L56 1" stroke="white" strokeWidth="3" /> */}
                                        <path d="M28 21L56 21" stroke="black" strokeWidth="3" />
                                        <path d="M0 41H56" stroke="black" strokeWidth="3" />
                                    </svg>}
                                    


                                </a>

                           </div>
                                



                        }
                        {/* ............................................................................................ */}
                    </div>
                </div >
            </nav >


        </>
    )
}

export default Navbar